
  <div class="modal-header">
    <h4 class="modal-title">File Viewer</h4>
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="usePrism && fileContent">
      <pre><code [ngClass]="'language-'+language" [textContent]="fileContent"></code></pre>
    </div>
      <div *ngIf="!usePrism && csvHeaders && csvData">
          <table>
            <thead>
              <tr>
                <th *ngFor="let header of csvHeaders">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of csvData">
                <td *ngFor="let cell of row">{{ cell }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!usePrism && !csvHeaders && fileContent && language === 'none'">
          <pre>{{fileContent}}</pre>
      </div>
      <div *ngIf="!fileContent">
          <p>Loading file content...</p>
      </div>
  </div>


